import { createBrowserRouter, Navigate } from "react-router-dom";
import { AppLayout } from "@/components/layout/AppLayout";
import { ProgressLayout } from "@/components/layout/ProgressLayout";
import { SubscriptionLayout } from "@/components/layout/SubscriptionLayout";
import { TrackPage } from "@/pages/Track/TrackPage";
import { ManualTrackPage } from "@/pages/Track/ManualTrackPage";
import { StatsOverviewPage } from "@/pages/Progress/StatsOverviewPage";
import { StatsPerExercisePage } from "@/pages/Progress/StatsPerExercisePage";
import { WorkoutsPage } from "@/pages/Progress/WorkoutsPage";
import WorkoutSetEditPage from "@/pages/WorkoutSetEditPage";
import { SettingsPage } from "@/pages/Settings/SettingsPage";
import { SettingsExercisesPage } from "@/pages/Settings/SettingsExercisesPage";
import { SettingsExerciseDetailPage } from "@/pages/Settings/SettingsExerciseDetailPage";
import { SettingsPreferencesPage } from "@/pages/Settings/SettingsPreferencesPage";
import { SettingsProfilePage } from "@/pages/Settings/SettingsProfilePage";
import { SettingsSubscriptionPage } from "@/pages/Settings/SettingsSubscriptionPage";
import { SettingsSubscriptionSuccessPage } from "@/pages/Settings/SettingsSubscriptionSuccessPage";
import { SettingsSubscriptionCancelPage } from "@/pages/Settings/SettingsSubscriptionCancelPage";
import { MatesPage } from "@/pages/Settings/MatesPage";
import { SettingsHelpPage } from "@/pages/Settings/SettingsHelpPage";
import { InviteAcceptPage } from "@/pages/InviteAcceptPage";
import { MateProfilePage } from "@/pages/Mates/MateProfilePage";
import LoginPage from "@/pages/LoginPage";
import { PasswordLogin } from "@/pages/PasswordLogin";
import NotFoundPage from "@/pages/NotFoundPage";
import { ProtectedRoute } from "@/components/auth/ProtectedRoute";
import BrandThemePage from "@/pages/Branding/BrandThemePage";
import AppleCallback from "@/pages/Auth/AppleCallback";

// App routes

export const router = createBrowserRouter([
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/password-login",
    element: <PasswordLogin />,
  },
  {
    path: "/track",
    element: (
      <ProtectedRoute>
        <AppLayout />
      </ProtectedRoute>
    ),
    children: [
      {
        path: "/track/manual",
        element: <ManualTrackPage />,
      },
      {
        path: "/track",
        element: <TrackPage />,
      },
    ],
  },

  {
    path: "/settings",
    element: (
      <ProtectedRoute>
        <AppLayout />
      </ProtectedRoute>
    ),
    children: [
      {
        path: "/settings/exercises/:exerciseNanoId",
        element: <SettingsExerciseDetailPage />,
      },
      {
        path: "/settings/exercises",
        element: <SettingsExercisesPage />,
      },
      {
        path: "/settings/preferences",
        element: <SettingsPreferencesPage />,
      },
      {
        path: "/settings/profile",
        element: <SettingsProfilePage />,
      },
      {
        path: "/settings/mates",
        element: <MatesPage />,
      },
      {
        path: "/settings/help",
        element: <SettingsHelpPage />,
      },
      {
        path: "/settings",
        element: <SettingsPage />,
      },
    ],
  },
  {
    path: "/settings/subscription",
    element: (
      <ProtectedRoute>
        <SubscriptionLayout />
      </ProtectedRoute>
    ),
    children: [
      {
        path: "/settings/subscription/success",
        element: <SettingsSubscriptionSuccessPage />,
      },
      {
        path: "/settings/subscription/cancel",
        element: <SettingsSubscriptionCancelPage />,
      },
      {
        path: "/settings/subscription",
        element: <SettingsSubscriptionPage />,
      },
    ],
  },
  {
    path: "/workouts",
    element: (
      <ProtectedRoute>
        <ProgressLayout />
      </ProtectedRoute>
    ),
    children: [
      {
        path: "/workouts/set/:nano_id",
        element: <WorkoutSetEditPage />,
      },
      {
        path: "/workouts/date/:date",
        element: <WorkoutsPage />,
      },
      {
        path: "/workouts",
        element: <WorkoutsPage />,
      },
    ],
  },
  {
    path: "/stats",
    element: (
      <ProtectedRoute>
        <ProgressLayout />
      </ProtectedRoute>
    ),
    children: [
      {
        path: "/stats/exercise-overview/:exerciseNanoId",
        element: <StatsPerExercisePage />,
      },
      {
        path: "/stats",
        element: <StatsOverviewPage />,
      },
    ],
  },
  {
    path: "/theme",
    element: <BrandThemePage />,
  },
  {
    path: "/auth/apple/callback",
    element: <AppleCallback />,
  },
  {
    path: "/invites/:token",
    element: (
      <ProtectedRoute>
        <InviteAcceptPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/mates/:mateshipId",
    element: (
      <ProtectedRoute>
        <AppLayout />
      </ProtectedRoute>
    ),
    children: [
      {
        path: "/mates/:mateshipId",
        element: <MateProfilePage />,
      },
    ],
  },
  {
    path: "/404",
    element: <NotFoundPage />,
  },
  {
    path: "/",
    element: <Navigate to="/track" replace />,
  },
  {
    path: "*", // Catch all unmatched routes
    element: <NotFoundPage />,
  },
]);
